export default __webpack_public_path__ + "static/nyugdij-b5c412052e443c6623c21eaf8bdbcdb6.jpg";